import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const updateVersion = async (payload) => {
    try {        
        let { status } = await axios.put(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/versions`,payload);
        if (status === 200) {
            addNotification({
                title: "Techforce.ai",
                message: "Version has been updated Successfully",
                type: "success"
            });
        }
    } catch (err) {
        console.log("Error while updating version", err.message);
        addNotification({
            title: "Techforce.ai",
            message: "Please write to support",
            type: "danger"
        });
    }
};
